import { defineComponent as _defineComponent } from 'vue'
import {
	withDefaults,
	computed,
	ComputedRef,
} from "vue"

import store from "@/vue/planning/store/store"
import Prices from "@/vue/planning/components/common/prices.vue"
import SelectButton from "@/vue/planning/components/result/selectBtn.vue"
import responsesCache from "@/vue/planning/state/responsesCache"
import pricesLoadingSet from "@/vue/planning/state/pricesLoadingSet"
import currentCacheKey from "@/vue/planning/computed/currentCacheKey"
import PackageDetalisPopUp from "@/vue/planning/components/result/prestation/packageDetalisPopUp.vue"
import PaymentCondition from "@/vue/planning/components/result/prestation/PaymentCondition.vue"
import Inclus from "@/vue/planning/components/result/prestation/inclus.vue";

// import FixFlexTag from "@/vue/planning/components/result/prestation/FixFlexTag.vue";

import {
	getPrestCrossedPrice,
	getPrestTotalPrice,
	// getPrestPerPrice,
	getPrestMaxPromo,
} from "@/logic/pricesAndDiscount"
import { getCancellationLastDate } from "@/vue/planning/logic/zeroCode"
import { isCS } from "@/vue/planning/logic/cs"

interface Props {
	variant: any
}
interface Emits {
	(e: "select", id: string): void
	(e: "clear", id: string): void
	(e: "dropdownSelect", selectedData: { newSelected: number; id: string }): void
	(e: "dropdownClick", obj: any): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PrestVariantPierreVacance',
  props: {
    variant: { default: {} }
  },
  emits: ["select", "clear", "dropdownSelect", "dropdownClick"],
  setup(__props: any, { emit }: { emit: ({
	(e: "select", id: string): void
	(e: "clear", id: string): void
	(e: "dropdownSelect", selectedData: { newSelected: number; id: string }): void
	(e: "dropdownClick", obj: any): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { variant: any };




// computed
const selectedQuantity: ComputedRef<number> = computed(() => {
	return store.state.selectedPrestIds[props.variant.id]
})

const isFlex: ComputedRef<boolean> = computed(() => {
	return props.variant.pvFlex === "flex"
})

const crossedPrice: ComputedRef<number> = computed(() => {
	if (!props.variant) return NaN
	const pricesResponse = responsesCache.value.getResponse(
		"prices",
		currentCacheKey.value
	)
	return props.variant && getPrestCrossedPrice(props.variant, !!pricesResponse)
})

const perPrice: ComputedRef<number> = computed(() => {
	return NaN
	// return props.variant && getPrestPerPrice(props.variant, this.participants.length)
})

const totalPrice: ComputedRef<number> = computed(() => {
	return props.variant && getPrestTotalPrice(props.variant)
})

const maxPromo: ComputedRef<number> = computed(() => {
	return props.variant && getPrestMaxPromo(props.variant)
})
const cancellationLastDate: ComputedRef<string> = computed(() => {
	return getCancellationLastDate(props.variant, store.getters.locale)
})

const prestID: ComputedRef<string> = computed(() => {
	const isPvFlex = props.variant.pvFlex ? true : false
	const prestIDToDisplay = isPvFlex ? props.variant.prestIdSource : ""
	return prestIDToDisplay
})

const specialStay: ComputedRef<boolean> = computed(() => {
	return (props.variant && isCS(props.variant)) || (props.variant && props.variant.isNewSkiPassValid)
});


return { __sfc: true,props, emit, selectedQuantity, isFlex, crossedPrice, perPrice, totalPrice, maxPromo, cancellationLastDate, prestID, specialStay, store, Prices, SelectButton, pricesLoadingSet, currentCacheKey, PackageDetalisPopUp, PaymentCondition, Inclus }
}

})